module.exports = __webpack_public_path__ + "img/BIT_white14.2d4b61e9.jpg";